import { render } from "./allExpenses.vue?vue&type=template&id=1f313b44&scoped=true"
import script from "./allExpenses.vue?vue&type=script&lang=js"
export * from "./allExpenses.vue?vue&type=script&lang=js"

import "./allExpenses.vue?vue&type=style&index=0&id=1f313b44&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/gafwa_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f313b44"]])

export default __exports__